import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import {
  Row,
  Col,
  Button,
} from 'reactstrap';

import { connect } from 'react-redux';

import Hierarchy1 from '../ReactIcons/Hierarchy1';
import BoxGift1 from '../ReactIcons/BoxGift1';
import Trophy from '../ReactIcons/Trophy';
import TrendDown1 from '../ReactIcons/TrendDown1';

import CampaignCard from './DashboardInfoBox2Card.js';

class DashboardInfoBox2 extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    admin: PropTypes.shape(),
  };

  static defaultProps = {
    user: {},
    admin: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      enabled: false,
      deleteSettingModal: false,
      deleteSettingErr: null,
      settingToDelete: null,
      activeTab: '1',
      companyNotification: '',
      allChecked: true,
      checked: {},
      companyNotifications: [],
      companyInformation: '',
      selectedStep: 1,
      purchaseModal: false,
      showPassword1: 'password',
    };
  }

  componentDidMount() {
    const { user } = this.props;

  }

  handleResize = () => {
    const width = window.innerWidth;
    let items = 8;
    if (width > 992) {
      items = 8;
    } else if (width > 762) {
      items = 6;
    } else if (width > 576) {
      items = 4;
    } else {
      items = 2;
    }

    this.setState({
      sliderSettings: {
        lazyload: true,
        autoplay: true,
        autoplayButtonOutput: false,
        mouseDrag: true,
        gutter: 15,
        nav: false,
        controls: false,
        items: items,
      },
    });
  };

  fetchDisablePerksTab = () => {
    const { fetchDisablePerksTab } = this.props;

    fetchDisablePerksTab().then((res2) => {
      this.setState({ disablePerks: res2 });
    })
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  render() {
    const { featured, setActiveTabPopularVouhers, scrollToAllVouchers, customer } = this.props;
    const {
      sliderSettings,
    } = this.state;

    console.log('customerstate', customer);

    return (
      <div style={{ marginBottom: -220 }}>
        <section className="info-box2">
          <div className="container">
            <Row>
              <Col xs="12" md="6" className="info-box2-left">
                <Row>
                  <Col xs="12">
                    <div className="info-box2-title" >Treat yourself or surprise someone special - all while saving and supporting independents</div>
                  </Col>
                </Row>
                <Row>
                  <Col xs="4" sm="4" md="4" className="single-info-box2-item" onClick={() => setActiveTabPopularVouhers(2)}>
                    <div className="icon single-info-box2-item-icon" style={{ justifyContent: 'left', display: 'inline-block', float: 'left' }} >
                      <Trophy />
                    </div>
                    <h5 className="single-info-box2-item-text"><div>Exclusive</div> <div>Vouchers</div></h5>
                  </Col>

                  <Col xs="4" sm="4" md="4" className="single-info-box2-item" onClick={() => setActiveTabPopularVouhers(4)}>
                    <div className="icon single-info-box2-item-icon" style={{ justifyContent: 'left', display: 'inline-block', float: 'left' }} >
                      <TrendDown1 />
                    </div>
                    <h5 className="single-info-box2-item-text"><div>Lower</div><div> Prices</div></h5>
                  </Col>

                  <Col xs="4" sm="4" md="4" className="single-info-box2-item" onClick={() => setActiveTabPopularVouhers(3)}>
                    <div className="icon single-info-box2-item-icon" style={{ justifyContent: 'left', display: 'inline-block', float: 'left' }} >
                      <BoxGift1 />
                    </div>
                    <h5 className="single-info-box2-item-text"><div>Great</div><div> Gifts</div></h5>
                  </Col>
                </Row>
              </Col>
              <Col xs="12" md="6">
                <Row>
                  <Col xs="12" md="8">
                    <CampaignCard
                      type={'featured1'}
                      key={'top-pick'}
                      display={true}
                      voucher={(featured && featured[0]) ? featured[0] : undefined}
                      voucherId={(featured && featured[0]) ? featured[0].key : null}
                    />
                  </Col>
                  <Col xs="0" md="4" style={{ display: 'flex', alignItems: 'end', paddingLeft: 0 }}>
                    <div className="single-info-box2-description">
                      {(featured && featured[0] && featured[0].description) ? (featured[0].description) : ''}
                    </div>
                  </Col>
                </Row>
              </Col>
                <Col xs="12" md="6">
                  <Button color="link" onClick={scrollToAllVouchers} className="single-info-box2-link">
                    All Vouchers
                    <i class="lni lni-arrow-right" style={{ height: 22, lineHeight: "22px", paddingLeft: 8, paddingTop: 1 }}></i>
                </Button>

                <Button color="link" onClick={scrollToAllVouchers} className="single-info-box2-link single-info-box2-link2">
                  Lock In Savings Now
                </Button>
                
                </Col>
            </Row>
          </div>
        </section>
      </div >
    );
  }
}

const mapStateToProps = state => ({
  featured: state.customer.featured || null,
  customer: state.customer || null,
});

const mapDispatchToProps = {
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardInfoBox2));
